module.exports = __webpack_public_path__ + "static/img/coin_a.69756b25.png";